// @ts-ignore
import FilterField2String from "../filter-fields3/string";
// @ts-ignore
import FilterField2Number from "../filter-fields3/number";
import FilterField2Dropdown from "../filter-fields3/dropdown";
// @ts-ignore
import FilterField2Multiselect from "../filter-fields3/multiselect";
// @ts-ignore
import FilterField2Boolean from "../filter-fields3/boolean";
// @ts-ignore
import FilterField2Date from "../filter-fields3/date";
// @ts-ignore
import FilterField2Rating from "../filter-fields3/rating";
// @ts-ignore
import FilterField2User from "../filter-fields3/user";
// @ts-ignore
import FilterField2RAG from "../filter-fields3/rag";

import {FieldFilterType} from "../../../fields3/proto/types";
import FilterField3_DropdownDynamic from "../filter-fields3/dropdown-dynamic";

const classes = {
    [FieldFilterType.STRING]            : FilterField2String,
    [FieldFilterType.NUMBER]            : FilterField2Number,
    [FieldFilterType.DROPDOWN]          : FilterField2Dropdown,
    [FieldFilterType.DROPDOWN_DYNAMIC]  : FilterField3_DropdownDynamic,
    [FieldFilterType.MULTISELECT]       : FilterField2Multiselect,
    [FieldFilterType.BOOLEAN]           : FilterField2Boolean,
    [FieldFilterType.DATE]              : FilterField2Date,
    [FieldFilterType.RATING]            : FilterField2Rating,
    [FieldFilterType.USER]              : FilterField2User,
    [FieldFilterType.RAG]               : FilterField2RAG,
};

export default function FilterFactory2 (filterType: FieldFilterType) {
    // @ts-ignore
    if (classes[filterType]) return classes[filterType];

    console.error("FilterFactory2: Unknown filter field", filterType);
    return false;
}
